import { useState, useEffect } from 'react'
import ProductsApiHandler from 'lib/api/products'

function useUpsells(productId) {
  const [list, setList] = useState([])
  const [isFetched, setIsFetched] = useState(false)

  useEffect(() => {
    let ignore = false

    async function fetchUpsells() {
      if (!ignore) {
        const upsells = await ProductsApiHandler.getUpSellsByProduct(productId)
        setList(upsells)
        setIsFetched(true)
      }
    }

    fetchUpsells()

    return () => {
      ignore = true
    }
  }, [productId])

  return [list, isFetched]
}

export default useUpsells
